/* ============================================================
   custom-variant-table.js  (v2)
   Tabla de variantes por color + barra fija de pedido — tema Rise.
   Novedades v2:
   - Apertura automática del cajón del carrito (cart-drawer) al agregar
   - Chips del resumen clicables: popup para editar cantidad por variante
   - Botón cambia a #2242F2 con letras blancas al agregar con éxito
   ============================================================ */

(function () {
  'use strict';

  if (window.__customVariantTableInit) return;
  window.__customVariantTableInit = true;

  /* ---------- Formateo de moneda ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';

    switch (key) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ---------- Helpers ---------- */
  function getStickyBar() {
    return document.querySelector('.sticky_action_bar');
  }

  function getGridInput(varId) {
    var box = document.querySelector('.custom_design_variant .variant_quantity[data-var-id="' + varId + '"]');
    return box ? box.querySelector('.quantity-input') : null;
  }

  function recalcTotals() {
    var bar = getStickyBar();
    if (!bar) return;

    var items = bar.querySelectorAll('.pro_var_grid .color_vari_item');
    var totalItems = 0;
    var totalPrice = 0;

    items.forEach(function (item) {
      var qty = parseInt(item.textContent, 10) || 0;
      var price = parseInt(item.getAttribute('data-variant-price'), 10) || 0;
      totalItems += qty;
      totalPrice += price * qty;
    });

    var piceEl = bar.querySelector('.pro_var_price .var_pice');
    var priceEl = bar.querySelector('.pro_var_price .var_price');
    if (piceEl) piceEl.textContent = totalItems;
    if (priceEl) priceEl.innerHTML = formatMoney(totalPrice, bar.getAttribute('data-money-format'));

    if (items.length > 0) {
      bar.classList.remove('hidden');
    } else {
      bar.classList.add('hidden');
      closePopup();
    }
  }

  function setVariantQty(varId, qty) {
    // Sincroniza chip + input de la cuadrícula y recalcula totales
    var input = getGridInput(varId);
    if (input) input.value = qty;

    var bar = getStickyBar();
    if (!bar) return;
    var chip = bar.querySelector('.pro_var_grid .color_vari_item[data-variant-id="' + varId + '"]');
    if (chip) {
      chip.textContent = qty;
      if (qty === 0) chip.remove();
    }
    recalcTotals();
  }

  /* ---------- Botones +/− de la cuadrícula ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qtybox .btnqty');
    if (!btn) return;

    var qtyboxEl = btn.closest('.qtybox');
    var variantBox = btn.closest('.variant_quantity');
    if (!qtyboxEl || !variantBox) return;

    var maxQty = parseInt(variantBox.getAttribute('data-variant-quantity'), 10);
    if (isNaN(maxQty) || maxQty < 0) maxQty = 0;

    var input = qtyboxEl.querySelector('.quantity-input');
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) qty = 0;

    if (btn.classList.contains('qtyplus')) {
      if (qty >= maxQty) return;
      qty++;
    } else {
      if (qty > 0) qty--;
    }

    input.value = qty;

    var varId = variantBox.getAttribute('data-var-id');
    var bar = getStickyBar();
    if (!bar) return;

    var grid = bar.querySelector('.pro_var_grid');
    var chip = grid.querySelector('.color_vari_item[data-variant-id="' + varId + '"]');

    if (chip) {
      chip.textContent = qty;
      if (qty === 0) chip.remove();
    } else if (qty !== 0) {
      var newChip = document.createElement('div');
      newChip.className = 'color_vari_item';
      newChip.style.backgroundColor = variantBox.getAttribute('data-bg-color') || '';
      newChip.style.color = variantBox.getAttribute('data-text-color') || '#000';
      newChip.setAttribute('data-variant-id', varId);
      newChip.setAttribute('data-variant-price', variantBox.getAttribute('data-price') || '0');
      newChip.setAttribute('data-variant-title', variantBox.getAttribute('data-var-title') || '');
      newChip.setAttribute('data-variant-sku', variantBox.getAttribute('data-var-sku') || '');
      newChip.setAttribute('data-max', variantBox.getAttribute('data-variant-quantity') || '0');
      newChip.setAttribute('title', variantBox.getAttribute('data-var-title') || '');
      newChip.textContent = qty;
      grid.appendChild(newChip);
    }

    recalcTotals();
  });

  /* ---------- Popup de edición desde los chips ---------- */
  var activePopupVarId = null;

  function closePopup() {
    activePopupVarId = null;
    var pop = document.querySelector('.cvt_popup');
    var overlay = document.querySelector('.cvt_popup_overlay');
    if (pop) pop.remove();
    if (overlay) overlay.remove();
  }

  function openPopup(chip) {
    closePopup();

    var varId = chip.getAttribute('data-variant-id');
    var title = chip.getAttribute('data-variant-title') || 'Variante';
    var sku = chip.getAttribute('data-variant-sku') || '';
    var bgColor = chip.style.backgroundColor || '#fff';
    var qty = parseInt(chip.textContent, 10) || 0;

    activePopupVarId = varId;

    var overlay = document.createElement('div');
    overlay.className = 'cvt_popup_overlay';
    overlay.addEventListener('click', closePopup);

    var pop = document.createElement('div');
    pop.className = 'cvt_popup';
    pop.innerHTML =
      '<button type="button" class="cvt_popup_close" aria-label="Cerrar">&times;</button>' +
      '<div class="cvt_popup_swatch"></div>' +
      '<div class="cvt_popup_title"></div>' +
      '<div class="cvt_popup_sku"></div>' +
      '<div class="cvt_qty_controls">' +
      '  <button type="button" class="cvt_minus" aria-label="Disminuir">&minus;</button>' +
      '  <span class="cvt_qty_value"></span>' +
      '  <button type="button" class="cvt_plus" aria-label="Aumentar">+</button>' +
      '</div>' +
      '<button type="button" class="cvt_remove">Quitar del pedido</button>';

    pop.querySelector('.cvt_popup_swatch').style.backgroundColor = bgColor;
    pop.querySelector('.cvt_popup_title').textContent = title;
    pop.querySelector('.cvt_popup_sku').textContent = sku;
    pop.querySelector('.cvt_qty_value').textContent = qty;

    pop.querySelector('.cvt_popup_close').addEventListener('click', closePopup);

    pop.querySelector('.cvt_minus').addEventListener('click', function () {
      var current = parseInt(pop.querySelector('.cvt_qty_value').textContent, 10) || 0;
      if (current <= 0) return;
      current--;
      if (current === 0) {
        setVariantQty(varId, 0);
        closePopup();
        return;
      }
      pop.querySelector('.cvt_qty_value').textContent = current;
      setVariantQty(varId, current);
    });

    pop.querySelector('.cvt_plus').addEventListener('click', function () {
      var max = parseInt(chip.getAttribute('data-max'), 10);
      if (isNaN(max) || max < 0) max = 0;
      var current = parseInt(pop.querySelector('.cvt_qty_value').textContent, 10) || 0;
      if (current >= max) return;
      current++;
      pop.querySelector('.cvt_qty_value').textContent = current;
      setVariantQty(varId, current);
    });

    pop.querySelector('.cvt_remove').addEventListener('click', function () {
      setVariantQty(varId, 0);
      closePopup();
    });

    document.body.appendChild(overlay);
    document.body.appendChild(pop);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.sticky_action_bar .pro_var_grid .color_vari_item');
    if (!chip) return;
    openPopup(chip);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  /* ---------- Agregar todo al carrito ---------- */
  document.addEventListener('click', function (e) {
    var actionBtn = e.target.closest('.sticky_action_bar .action_btn');
    if (!actionBtn) return;
    e.preventDefault();

    var bar = getStickyBar();
    var chips = bar.querySelectorAll('.pro_var_grid .color_vari_item');
    if (!chips.length) return;

    closePopup();

    var items = [];
    chips.forEach(function (chip) {
      items.push({
        id: parseInt(chip.getAttribute('data-variant-id'), 10),
        quantity: parseInt(chip.textContent, 10) || 0,
      });
    });

    var defaultText = 'AGREGAR AL CARRITO';
    actionBtn.textContent = 'Añadiendo...';
    actionBtn.disabled = true;

    // Replicamos el patrón nativo de Rise (product-form.js):
    // pedimos exactamente las secciones que el cart-drawer sabe renderizar
    // y usamos el pathname actual como sections_url.
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsToRequest = ['cart-drawer', 'cart-icon-bubble'];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsToRequest = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(document.activeElement);
    }

    var cartAddUrl =
      (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionsToRequest,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            throw new Error(json.description || json.message || 'Error al agregar al carrito');
          }
          return json;
        });
      })
      .then(function (json) {
        var drawerOpened = false;

        // 1) Carrito tipo cajón: refresca contenido y ábrelo
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && json.sections) {
          try {
            // FIX: si el carrito estaba vacío al cargar la página, el
            // <cart-drawer> nace con la clase 'is-empty' y Rise intenta
            // enfocar '.drawer__inner-empty' (que ya no existe) -> truena
            // y el cajón sale vacío en la primera adición. Quitamos esa
            // clase ANTES de renderizar para que tome la rama correcta.
            cartDrawer.classList.remove('is-empty');
            var innerEl = cartDrawer.querySelector('.drawer__inner');
            if (innerEl) innerEl.classList.remove('is-empty');

            cartDrawer.renderContents(json);
            drawerOpened = true;
          } catch (err) {
            console.warn('No se pudo abrir el cajón del carrito:', err);
          }
        }

        // 2) Respaldo: actualiza el contador del carrito en el header
        if (!drawerOpened && json.sections && json.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var parsed = new DOMParser().parseFromString(
              json.sections['cart-icon-bubble'],
              'text/html'
            );
            var sectionContent = parsed.querySelector('.shopify-section');
            if (sectionContent) bubble.innerHTML = sectionContent.innerHTML;
          }
        }

        // 3) Estado de éxito: fondo #2242F2 y letras blancas
        actionBtn.textContent = 'AGREGADO CON ÉXITO ✓';
        actionBtn.classList.add('added');

        setTimeout(function () {
          actionBtn.textContent = defaultText;
          actionBtn.classList.remove('added');
          actionBtn.disabled = false;
        }, 2500);

        setTimeout(function () {
          document.querySelectorAll('.custom_design_variant .quantity-input').forEach(function (input) {
            input.value = 0;
          });
          bar.querySelectorAll('.pro_var_grid .color_vari_item').forEach(function (chip) {
            chip.remove();
          });
          bar.classList.add('hidden');
        }, 2550);
      })
      .catch(function (error) {
        console.error('Error:', error);
        actionBtn.textContent = 'ERROR — INTENTA DE NUEVO';
        setTimeout(function () {
          actionBtn.textContent = defaultText;
          actionBtn.disabled = false;
        }, 2500);
      });
  });
})();